var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import Header from "./components/Header.vue";
import Table from "./components/Table.vue";
import GLOBAL_VUE from '../../globalVue';
import Add from "./Add";
import EQuotedPriceType from "../../enum/EQuotedPriceType";
import _ from 'lodash';
import QuotedPrice from '../../api/QuotedPrice';
import { Loading } from 'element-ui';
import { toDetail } from '../../helper/util';
import { EBillType } from '../../enum/EBillType';
import { UrlHelper } from "../../helper/UrlWrapper";
import { mapGetters } from "vuex";
import ImportData from "../../components/dataActions/ImportData.vue";
import CommonService from "../../api/CommonService";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.total = 10;
        _this.data = [];
        _this.priceType = EQuotedPriceType;
        return _this;
    }
    default_1.prototype.created = function () {
        this.service = QuotedPrice.getInstance();
        this.commonService = CommonService.getInstance();
    };
    default_1.prototype.batchImportEdit = function () {
        this.$refs.ImportData.showImportModal();
    };
    default_1.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        filter.order_status = filter.order_status.join(',');
        this.filter = filter;
        this.getList();
    };
    default_1.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getOrderList(Object.assign(this.filter, pager)).then(function (res) {
            loadingInstance.close();
            _this.data = res.data.data;
            _this.total = res.data.total;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    default_1.prototype.selectionChange = function (rows) {
        this.tempSelectRows = rows;
    };
    default_1.prototype.addTab = function (options) {
        options.opener = this;
        GLOBAL_VUE.$emit('addTab', options);
    };
    default_1.prototype.toAdd = function (type) {
        this.addTab({
            component: Add,
            title: '添加报价单',
            showExist: true,
            name: 'add-quotedprice' + type,
            cprops: {
                priceType: type
            }
        });
    };
    default_1.prototype.submit = function () {
        var _this = this;
        if (!this.tempSelectRows || !this.tempSelectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        this.$confirm("提交后不可修改，请确认是否继续。").then(function () {
            _this.submitContinue();
        }, function (err) { });
    };
    default_1.prototype.submitContinue = function (null_quotation_alert) {
        var _this = this;
        var nextActionToCancelFlag = 1;
        var nextActionToSureFlag = 2;
        var loadingInstance = Loading.service({ fullscreen: true });
        var order_id = this.tempSelectRows.map(function (item) { return item.order_id; }).join(",");
        var params = [order_id];
        this.service.submit(order_id, null_quotation_alert).then(function (res) {
            loadingInstance.close();
            if (res.data.code == 76) {
                _this.$message.error(res.data.msg);
            }
            else {
                _this.$message.success("提交成功");
            }
            _this.getList();
            window._czc.push(["_trackEvent", '报价单提交', '报价单提交', '提交成功']);
        }).catch(function (err) {
            window._czc.push(["_trackEvent", '报价单提交', '报价单提交', '提交失败']);
            loadingInstance.close();
            if (err.resData && err.resData.flag === nextActionToCancelFlag) {
                _this.$confirm(err.resData.msg).then(function (res) {
                    _this.service.cancelByBusiness(err.resData.data).then(function (res) {
                        loadingInstance.close();
                        _this.getList();
                    }).catch(function (err) {
                        loadingInstance.close();
                        _this.$message.error(err.msg || err.message);
                    });
                });
            }
            else if (err.resData && err.resData.flag === nextActionToSureFlag) {
                _this.$confirm(err.resData.msg).then(function (res) {
                    var null_quotation_alert = 0;
                    _this.submitContinue(null_quotation_alert);
                });
            }
            else {
                _this.$message.error(err.msg || err.message);
            }
        });
    };
    default_1.prototype.cancel = function () {
        var _this = this;
        if (!this.tempSelectRows || !this.tempSelectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        this.$confirm("请确认是否废弃该报价单。").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.cancel(_this.tempSelectRows.map(function (item) { return item.order_id; }).join(",")).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success("废弃成功");
                }
                _this.getList();
                window._czc.push(["_trackEvent", '报价单废弃', '报价单废弃']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    default_1.prototype.getSelectIds = function () {
        var orderIds = this.tempSelectRows.map(function (item) { return item.order_id; });
        return orderIds;
    };
    default_1.prototype.exportData = function () {
        var _this = this;
        var orderIds = this.getSelectIds();
        var url = 'supplierclientapi/quotationorder/export?order_ids=' + orderIds.join(",");
        url = UrlHelper.addParam(url, 'token', this.user.token);
        var filter = _.cloneDeep(this.$refs.listHeader.formData);
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        filter.order_status = filter.order_status.join(',');
        this.filter = filter;
        for (var key in this.filter) {
            this.filter[key] = (this.filter[key] === undefined || this.filter[key] === null) ? '' : this.filter[key];
            url = UrlHelper.addParam(url, key, this.filter[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        window._czc.push(["_trackEvent", '报价单导出', '报价单导出']);
    };
    default_1.prototype.revoke = function () {
        var _this = this;
        if (!this.tempSelectRows || !this.tempSelectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        var params = {
            order_ids: this.tempSelectRows.map(function (item) { return item.order_id; }).join(",")
        };
        this.$confirm("撤回后，单据变为待提交状态。确定要撤回吗？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.revoke(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success("撤回成功");
                }
                _this.getList();
                window._czc.push(["_trackEvent", '报价单撤回', '报价单撤回']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    default_1.prototype.toDetail = function (row) {
        toDetail(EBillType.Quote, row.order_id, this);
    };
    default_1.prototype.mounted = function () {
        $(this.$refs.button).dropdown();
    };
    default_1 = __decorate([
        Component({
            components: {
                'list-header': Header,
                "list-table": Table,
                'import-data': ImportData,
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
